module.exports = __webpack_public_path__ + "images/Documents_fd111a8.png";